import React from 'react'
import type { MonthlySubscriptionsProps } from '@/features/enrollment'

export default function MonthlySubscriptions({ enrollmentData, updateEnrollmentData, errors, intakeGames, subscriptionsAutoSelected, setSubscriptionsAutoSelected, getSubscriptionsForGames }: MonthlySubscriptionsProps) {
  return (
    <div>
      <label className="block text-sm font-medium text-accent-900 mb-2">
        Which monthly subscription(s) did you purchase? <span className="text-red-500">*</span>
      </label>
      
      {/* Auto-selection indicator */}
      {intakeGames && intakeGames.length > 0 && (
        <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
          <p className="text-sm text-blue-800">
            <span className="font-medium">Auto-selected based on games from Step 2:</span>
            <span className="ml-2 text-blue-600">
              {getSubscriptionsForGames(intakeGames).join(', ')}
            </span>
          </p>
          <p className="text-xs text-blue-600 mt-1">
            These subscriptions were automatically selected based on the games you play. You can uncheck any that don't apply.
          </p>
        </div>
      )}
      
      <div className="grid grid-cols-2 gap-3">
        {[
          'Game Pass Ultimate', 'Game Pass Core', 'XBox Live Gold', 'Playstation Premium',
          'Playstation Extra', 'Playstation Essential', 'EA Play', 'EA Play Pro',
          'Apple Arcade', 'Google Play Pass', 'Amazon Prime Gaming', 'NVIDIA GeForce NOW',
          'Amazon Luna', 'Roblox Premim', 'Ubisoft Classics', 'Ubisoft Premium',
          'Fortnite Battlepass', 'Fortnite Crew Subscription', 'Other Subscription', 'No Monthly Subscription'
        ].map((subscription) => (
          <label key={subscription} className="flex items-center">
            <input 
              type="checkbox" 
              name="monthlySubscriptions"
              value={subscription}
              checked={(enrollmentData.monthlySubscriptions || []).includes(subscription)}
              onChange={(e) => {
                const currentSubs = enrollmentData.monthlySubscriptions || []
                if (e.target.checked) {
                  updateEnrollmentData('monthlySubscriptions', [...currentSubs, subscription])
                } else {
                  updateEnrollmentData('monthlySubscriptions', currentSubs.filter((s: string) => s !== subscription))
                }
                // Prevent auto-selection from interfering with user changes
                if (!subscriptionsAutoSelected) {
                  setSubscriptionsAutoSelected(true)
                }
              }}
              className="form-checkbox text-primary-600" 
            />
            <span className="ml-2 text-accent-700">{subscription}</span>
          </label>
        ))}
      </div>
      
      {/* Other Subscription Input */}
      {(enrollmentData.monthlySubscriptions || []).includes('Other Subscription') && (
        <div className="mt-3">
          <label className="block text-sm font-medium text-accent-900 mb-2">Other Subscription:</label>
          <input
            type="text"
            className="input-field w-full"
            placeholder="Specify other subscription"
            value={enrollmentData.otherSubscription || ''}
            onChange={(e) => updateEnrollmentData('otherSubscription', e.target.value)}
          />
        </div>
      )}
      
      {errors.monthlySubscriptions && (
        <p className="mt-1 text-sm text-red-600">{errors.monthlySubscriptions}</p>
      )}
    </div>
  )
}